var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTweeterFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.857,
    y1: 0.5,
    x2: 2.497,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3decd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#2a4792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28348b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_216",
    "data-name": "Groupe 216",
    transform: "translate(-291.628 -1591.147)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(291.628 1591.147)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M14.7,49.414a6.285,6.285,0,0,1-1.737.476,3,3,0,0,0,1.326-1.666,6.024,6.024,0,0,1-1.911.73,3.014,3.014,0,0,0-5.214,2.061,3.1,3.1,0,0,0,.07.687A8.532,8.532,0,0,1,1.024,48.55a3.015,3.015,0,0,0,.926,4.029,2.977,2.977,0,0,1-1.362-.371v.033A3.028,3.028,0,0,0,3,55.2a3.008,3.008,0,0,1-.79.1,2.665,2.665,0,0,1-.571-.051,3.043,3.043,0,0,0,2.817,2.1A6.057,6.057,0,0,1,.721,58.635,5.646,5.646,0,0,1,0,58.593a8.486,8.486,0,0,0,4.624,1.353A8.52,8.52,0,0,0,13.2,51.369c0-.133,0-.262-.011-.39A6.013,6.013,0,0,0,14.7,49.414Z",
    transform: "translate(299.379 1552.096)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweeterFooter);
export default __webpack_public_path__ + "static/media/tweeter_footer.3013262da671f55b6ba37e32cecd6a8f.svg";
export { ForwardRef as ReactComponent };